"use strict";
/** state: Final **/
/** family: Card **/
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var classNames = require("classnames");
var React = require("react");
var icon_types_1 = require("../../types/icon.types");
var Button_1 = require("../Button");
var CardHeader_1 = require("../CardHeader");
var Dropdown_1 = require("../Dropdown");
var utils_1 = require("../utils");
var CLASS_NAME = 'i-card__menu';
/**
 * The menu subcomponent for a card.
 *
 * CardMenu should only be used inside a Card.
 */
var CardMenu = /** @class */ (function (_super) {
    __extends(CardMenu, _super);
    function CardMenu(props) {
        var _this = _super.call(this, props) || this;
        _this.handleClick = function (e) {
            // Toggle Menu
            _this.setState(function (prevState) { return ({
                isMenuOpen: !prevState.isMenuOpen,
            }); });
            e.stopPropagation();
            // Triggering the click handler passed via prop.
            if (_this.props.onClick) {
                _this.props.onClick(e);
            }
        };
        _this.handleOutsideClick = function () {
            _this.setState({
                isMenuOpen: false,
            });
        };
        _this.handleSelect = function () {
            if (!_this.props.shouldStayOpen) {
                // close the menu if the user has not indicated otherwise
                _this.setState({
                    isMenuOpen: false,
                });
            }
        };
        _this.state = {
            isMenuOpen: false,
        };
        return _this;
    }
    CardMenu.prototype.render = function () {
        var _a, _b;
        var _c = this.props, children = _c.children, ariaLabelClose = _c.ariaLabelClose, className = _c.className, closeOnOutsideClick = _c.closeOnOutsideClick, id = _c.id, toggle = _c.toggle, restProps = __rest(_c, ["children", "ariaLabelClose", "className", "closeOnOutsideClick", "id", "toggle"]);
        var isHeaderMenu = false;
        React.Children.forEach(toggle, function (child) {
            if (!child || isHeaderMenu) {
                return;
            }
            if (utils_1.isType(child, CardHeader_1.CardHeader)) {
                isHeaderMenu = true;
            }
        });
        return (React.createElement(Dropdown_1.Dropdown, __assign({ id: id, role: Dropdown_1.Dropdown.Role.Menu, className: classNames(CLASS_NAME, className, (_a = {},
                _a[CLASS_NAME + "__ellipsis-btn__nonheader"] = !isHeaderMenu,
                _a)), onOutsideClick: closeOnOutsideClick && this.handleOutsideClick, onSelect: this.handleSelect, isOpen: this.state.isMenuOpen }, restProps, { toggle: React.createElement(React.Fragment, null,
                toggle,
                React.createElement("div", { className: classNames((_b = {},
                        _b[CLASS_NAME + "__ellipsis-btn__header"] = isHeaderMenu,
                        _b)) },
                    React.createElement(Button_1.Button, { id: id + "_ellipsis_btn", label: ariaLabelClose, labelHidden: true, iconName: icon_types_1.Icon.VerticalEllipsis, mode: Button_1.Button.Mode.Tertiary, onClick: this.handleClick }))) }), children));
    };
    return CardMenu;
}(React.Component));
exports.CardMenu = CardMenu;
//# sourceMappingURL=CardMenu.js.map